import React from "react";
import { UserGroupIcon } from "@heroicons/react/24/outline";
import ListItemTab from "./ListItemTab";

const 
StudentManagementItem = ({onClick, active}) => {
  return (
    <ListItemTab
      icon={UserGroupIcon}
      label="Student Management"
      onClick={onClick}
      active={active}
    />
  );
};

export default StudentManagementItem;
